// @flow
import React, { Component } from "react";
import BlockerPage from "../../../shared/components/BlockerPage";
import Analytics from "../../../shared/Analytics";

declare var chrome;

type Props = {
	url?: string,
	match: any,
};
type State = {};
class Blocker extends Component<Props, State> {
	handleCorrectCode = () => {
		var extension_id = process.env.EXTENSION_ID;
		let url = window.decodeURIComponent(this.props.match.params.encoded_url);

		chrome.runtime.sendMessage(
			extension_id,
			{
				type: "unblock",
				config: {
					url,
				},
			},
			() => {
				chrome.runtime.sendMessage(extension_id, {
					type: "redirect",
					config: {
						url,
					},
				});
			}
		);
	};

	componentDidMount() {
		Analytics.event({
			category: "Blocked Site",
			action: "Visited",
		});
	}

	render() {
		let url = this.props.match.params.encoded_url;
		return <BlockerPage onCorrectCode={this.handleCorrectCode} url={url} />;
	}
}

export default Blocker;



// WEBPACK FOOTER //
// ./src/pages/Blocker.js